"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserRole = void 0;
var create_entity_1 = require("../../utils/create-entity");
var entity_select_transform_1 = require("../../utils/entity-select-transform");
exports.UserRole = {
  name: 'UserRole',
  label: 'Member Role',
  slug: 'member-role',
  autoRoutes: ['list', 'create', 'update'],
  useCreator: false,
  useCreated: false,
  useOpenGraph: false,
  table: {
    fieldNames: ["name", "users", "permissions"]
  },
  select: {
    defaultOptions: true,
    canCreate: function () {
      return false;
    },
    transform: function (entity, context) {
      return __assign(__assign({}, (0, entity_select_transform_1.entitySelectTransform)(entity, context)), {
        description: entity.description
      });
    }
  },
  form: {
    fieldSets: [{
      name: 'overview'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      description: {
        type: 'text'
      },
      users: {
        type: "linkedMultiple",
        entityTypeName: "User",
        specOnly: true
      },
      permissions: {
        type: 'linked',
        entityTypeName: 'UserPermission',
        description: 'Assign the relevant platform permissions to this role, which define the actions that members in this role are allowed to perform.'
      }
    })
  },
  list: {
    banner: {
      content: 'Manage the member roles and permissions they allow within the platform.'
    },
    hasSearch: true,
    resultsVariant: "table"
  }
};